'use client';

var translations = {
    'New term of use and privacy policy': 'Thỏa thuận sử dụng và Quy định bảo mật mới',
    'Yes, I turn it on': 'Có, bật chia sẻ',
    'No, I turn it off': 'Không, tắt chia sẻ',
    'Yes, turn it off': 'Có, tắt chia sẻ',
    'No, keep sharing': 'Không, tiếp tục chia sẻ',
    'The following functions had granted permission': 'Những chức năng sau đã được cấp quyền',
    'Not able to apply for jobs on VietnamWorks': 'Không thể nộp đơn cho các công việc trên Vietnamworks',
    'Not able to make your profile searchable to Employers': 'Không thể cho phép nhà tuyển dụng tìm hồ sơ của bạn',
    'Not receive any in-app notifications': 'Không nhận bất cứ thông báo nào trên ứng dụng',
    'Not receive any emails from us': 'Không nhận bất kỳ email từ chúng tôi',
    'Status:': 'Trạng thái:',
    ON: 'BẬT',
    OFF: 'TẮT',
    'The following functions had been disabled': 'Những chức năng sau đã được vô hiệu',
    'Able to apply for jobs on VietnamWorks': 'Nộp đơn cho các công việc trên Vietnamworks',
    'Able to make your profile searchable to Employers': 'Cho phép nhà tuyển dụng tìm hồ sơ của bạn',
    'Allow to receive any in-app notifications': 'Nhận các thông báo trên ứng dụng',
    'Allow to receive any emails from us': 'Nhận các email từ chúng tôi',
    'Are you sure to turn off data sharing with us?': 'Bạn chắc chắn muốn tắt chia sẻ dữ liệu với chúng tôi?',
    'By clicking “Yes, turn it off", you will:': 'Bằng việc bấm "Có, tắt chia sẻ", bạn sẽ:',
    Cancel: 'Huỷ',
    Continue: 'Tiếp tục'
};

export { translations as default };
//# sourceMappingURL=translations.js.map
